import React, { useState, useEffect } from 'react';
import { Link, useLocation } from 'react-router-dom';

const Navbar = () => {
  const [isOpen, setIsOpen] = useState(false);
  const [scrolled, setScrolled] = useState(false);
  const location = useLocation();

  useEffect(() => {
    const handleScroll = () => {
      setScrolled(window.scrollY > 50);
    };
    window.addEventListener('scroll', handleScroll);
    return () => window.removeEventListener('scroll', handleScroll);
  }, []);

  // Fermer le menu quand l'URL change
  useEffect(() => {
    setIsOpen(false);
  }, [location.pathname]);

  const handleLinkClick = () => {
    setIsOpen(false);
  };

  return (
    <nav className={`fixed w-full z-50 transition-all duration-300 ${
      scrolled ? 'bg-blue-600/95 backdrop-blur-md shadow-lg' : 'bg-blue-600/90'
    }`}>
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="flex justify-between items-center h-16 sm:h-18 lg:h-20">
          {/* Logo */}
          <div className="flex-shrink-0">
            <Link 
              to="/" 
              onClick={handleLinkClick} 
              className="flex items-center hover:scale-105 transition-transform duration-300"
            >
              <img 
                src="/Logo.svg"
                alt="E-omi Services" 
                className="navbar-logo"
                style={{
                  filter: 'brightness(0) invert(1)',
                  height: 'clamp(2rem, 4vw, 3rem)',
                  width: 'auto',
                  maxWidth: 'clamp(140px, 20vw, 200px)'
                }}
                onError={(e) => {
                  // Essayer plusieurs fallbacks successifs
                  const el = e.target;
                  const candidates = ['/logo.svg', '/images/logo.svg', '/Group.svg', '/images/Group.svg'];
                  const idx = parseInt(el.dataset.fallbackIndex || '0', 10);
                  if (idx < candidates.length) {
                    el.dataset.fallbackIndex = String(idx + 1);
                    el.src = candidates[idx];
                  } else {
                    console.log('Erreur de chargement du logo, tous les fallbacks ont échoué:', el.src);
                    el.style.display = 'none';
                    if (el.nextSibling) {
                      el.nextSibling.style.display = 'block';
                    }
                  }
                }}
              />
              <span className="text-xl sm:text-2xl font-bold text-white font-mulish hidden">
                E-omi Services
              </span>
            </Link>
          </div>

          {/* Hamburger Menu Button */}
          <div className="lg:hidden">
            <button
              onClick={() => setIsOpen(!isOpen)}
              className="inline-flex items-center justify-center p-2 rounded-md text-white hover:text-blue-100 hover:bg-blue-700 focus:outline-none transition-colors duration-300"
              aria-expanded={isOpen}
            >
              <svg
                className={`h-6 w-6 transition-opacity duration-300 ${isOpen ? 'hidden' : 'block'}`}
                xmlns="http://www.w3.org/2000/svg"
                fill="none"
                viewBox="0 0 24 24"
                stroke="currentColor"
              >
                <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M4 6h16M4 12h16M4 18h16" />
              </svg>
              <svg
                className={`h-6 w-6 transition-opacity duration-300 ${isOpen ? 'block' : 'hidden'}`}
                xmlns="http://www.w3.org/2000/svg"
                fill="none"
                viewBox="0 0 24 24"
                stroke="currentColor"
              >
                <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M6 18L18 6M6 6l12 12" />
              </svg>
            </button>
          </div>

          {/* Desktop Menu */}
          <div className="hidden lg:block">
            <div className="ml-4 flex items-center space-x-2 sm:space-x-4">
              <Link to="/" className="nav-link" onClick={handleLinkClick}>
                Accueil
              </Link>
              <span className="text-white/30">|</span>
              <Link to="/services" className="nav-link" onClick={handleLinkClick}>
                Services
              </Link>
              <span className="text-white/30">|</span>
              <Link to="/about" className="nav-link" onClick={handleLinkClick}>
                À Propos
              </Link>
              <span className="text-white/30">|</span>
              <Link to="/contact" className="btn-primary text-sm sm:text-base" onClick={handleLinkClick}>
                Nous Contacter
              </Link>
            </div>
          </div>
        </div>

        {/* Mobile Menu */}
        <div 
          className={`${
            isOpen ? 'max-h-[calc(100vh-4rem)] opacity-100' : 'max-h-0 opacity-0'
          } lg:hidden transition-all duration-300 ease-in-out overflow-hidden bg-blue-600/95 backdrop-blur-md`}
        >
          <div className="px-2 pt-2 pb-3 space-y-1">
            <Link
              to="/"
              className="block px-3 py-2 rounded-md text-base font-medium text-white hover:text-blue-100 hover:bg-blue-700 transition-colors duration-300"
              onClick={handleLinkClick}
            >
              Accueil
            </Link>
            <Link
              to="/services"
              className="block px-3 py-2 rounded-md text-base font-medium text-white hover:text-blue-100 hover:bg-blue-700 transition-colors duration-300"
              onClick={handleLinkClick}
            >
              Services
            </Link>
            <Link
              to="/about"
              className="block px-3 py-2 rounded-md text-base font-medium text-white hover:text-blue-100 hover:bg-blue-700 transition-colors duration-300"
              onClick={handleLinkClick}
            >
              À Propos
            </Link>
            <Link
              to="/contact"
              className="block px-3 py-2 rounded-md text-base font-medium bg-white text-blue-600 hover:bg-blue-50 transition-colors duration-300 font-bold"
              onClick={handleLinkClick}
            >
              Nous Contacter
            </Link>
          </div>
        </div>
      </div>
    </nav>
  );
};

export default Navbar; 